import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Field, inputCls } from "@/components/LegsEditor";
import { useApi, errMsg } from "@/lib/api";
import { OFFICE_PHONE } from "@/lib/format";

export default function EditUserDialog({ user, onOpenChange, onSaved }) {
  const api = useApi();
  const [form, setForm] = useState({ name: "", title: "", phone: "", office_ext: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (user) { setForm({ name: user.name || "", title: user.title || "", phone: user.phone || "", office_ext: user.office_ext || "" }); }
  }, [user]);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.patch(`/users/${user.id}`, form);
      toast.success(`${form.name} updated`);
      onOpenChange(false);
      onSaved();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={!!user} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#111319] border-white/10 max-w-lg w-[calc(100%-2rem)] grid-cols-[minmax(0,1fr)]" data-testid="edit-user-dialog">
        <DialogHeader>
          <p className="eyebrow">{user?.email}</p>
          <DialogTitle className="font-serif-display text-3xl font-normal text-white">Edit user</DialogTitle>
        </DialogHeader>
        <form onSubmit={save} className="space-y-3 mt-2">
          <Field label="Full name"><Input className={inputCls} value={form.name} onChange={set("name")} required maxLength={120} data-testid="edit-user-name-input" /></Field>
          <Field label="Title"><Input className={inputCls} value={form.title} onChange={set("title")} maxLength={120} data-testid="edit-user-title-input" /></Field>
          <div className="grid grid-cols-[1fr_120px] gap-3">
            <Field label="Mobile phone"><Input className={inputCls} type="tel" value={form.phone} onChange={set("phone")} required minLength={7} maxLength={40} data-testid="edit-user-phone-input" /></Field>
            <Field label="Office ext."><Input className={inputCls} value={form.office_ext} onChange={set("office_ext")} maxLength={20} placeholder="Optional" data-testid="edit-user-ext-input" /></Field>
          </div>
          <p className="text-[11px] text-zinc-500">Office line {OFFICE_PHONE} is shown for every user.</p>
          <div className="flex flex-wrap justify-end gap-3 pt-3">
            <button type="button" className="frame-btn" onClick={() => onOpenChange(false)} data-testid="edit-user-cancel-btn">Cancel</button>
            <button type="submit" className="frame-btn gold" disabled={saving} data-testid="edit-user-save-btn">{saving ? "Saving…" : "Save"}</button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
